var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.28,
    height: 11.28
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 9.78L8.83 7.59a4.83 4.83 0 00-.56-6.17A4.78 4.78 0 004.85 0 4.85 4.85 0 000 4.85a4.84 4.84 0 007.59 4L9.78 11A.88.88 0 0011 9.78zM2.66 7a3.08 3.08 0 01-.91-2.19 3 3 0 01.91-2.19A3.16 3.16 0 017 2.66a3 3 0 01.91 2.19A3.1 3.1 0 012.66 7z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMS4yOCIgaGVpZ2h0PSIxMS4yOCIgdmlld0JveD0iMCAwIDExLjI4IDExLjI4Ij4KICA8cGF0aCBkPSJNMTEsOS43OCw4LjgzLDcuNTlhNC44Myw0LjgzLDAsMCwwLS41Ni02LjE3QTQuNzgsNC43OCwwLDAsMCw0Ljg1LDAsNC44NSw0Ljg1LDAsMCwwLDAsNC44NWE0Ljg0LDQuODQsMCwwLDAsNy41OSw0TDkuNzgsMTFBLjg4Ljg4LDAsMCwwLDExLDkuNzhaTTIuNjYsN2EzLjA4LDMuMDgsMCwwLDEtLjkxLTIuMTksMywzLDAsMCwxLC45MS0yLjE5QTMuMTYsMy4xNiwwLDAsMSw3LDIuNjZhMywzLDAsMCwxLC45MSwyLjE5QTMuMSwzLjEsMCwwLDEsMi42Niw3WiIvPgo8L3N2Zz4K";
export { SvgSearch as ReactComponent };